import React, { useState } from "react";
import "../Styles/BusBookingReviewPage.css";
import Navber from "./Navber.jsx"

const BookingReviewPage = () => {
    const [traveller, setTraveller] = useState({
        title: "MR.",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
    });

    return (
        <>
            <div style={{ backgroundColor: "#f0f0f0" }}>
                <Navber />
            </div>
            <div className="reviewbooking-container">
                {/* Heading */}
                <h2 className="reviewbooking-heading">Review your Booking</h2>

                <div className="reviewbooking-main">
                    {/* Bus Details */}
                    <div class="ride-card">
                        <div class="ride-header">
                            <div style={{width:"70%",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                <span class="ride-city" >Mumbai</span>
                                <span class="ride-line" style={{width:"100%"}}></span>
                                {/* <hr  style={{width:"5%"}}/> */}
                                <span class="ride-city">Pune</span>

                            </div>


                            <div class="ride-rating">
                                <span class="star">★</span> 4.3
                                {/* <span class="reviews">154 reviews</span> */}
                            </div>
                        </div>

                        <div class="ride-date">
                            <span class="calendar">📅</span> 04 Sept, 12:05 PM
                        </div>

                        <div class="ride-details">
                            <h3>Indica, Swift</h3>
                            <p>6 seats , AC</p>
                        </div>
                    </div>


                    {/* Price Details */}
                    <div className="reviewbooking-pricecard">
                        <h3>Price Details</h3>
                        <div className="reviewbooking-pricerow">
                            <span>Base Fare</span>
                            <span>359.0/-</span>
                        </div>
                        <hr />
                        <div className="reviewbooking-pricerow reviewbooking-total">
                            <span>Amount</span>
                            <span>359.0/-</span>
                        </div>
                        <button className="reviewbooking-bookbtn">Book Now</button>
                    </div>
                </div>

                {/* Traveller Details */}
                <div className="reviewbooking-travellercard">
                    <h3>Traveller’s Details</h3>

                    <label className="reviewbooking-checkbox">
                        <input type="checkbox" /> Same as Profile Information
                    </label>

                    <div className="reviewbooking-form">
                        <select
                            value={traveller.title}
                            onChange={(e) =>
                                setTraveller({ ...traveller, title: e.target.value })
                            }
                        >
                            <option>MR.</option>
                            <option>MRS.</option>
                            <option>MS.</option>
                        </select>

                        <input type="text" placeholder="First Name" />
                        <input type="text" placeholder="Last Name" />
                        <input type="email" placeholder="Enter email address" />
                        <input type="tel" placeholder="Enter Phone number" />
                    </div>

                    <button className="reviewbooking-addguest">+ Add Guest</button>
                </div>

                {/* Agreement */}
                <div className="reviewbooking-agreement">
                    <label>
                        <input type="checkbox" /> By proceeding, I agree to MakeMyTrip’s{" "}
                        <a href="#">User Agreement</a>,{" "}
                        <a href="#">Terms of Service</a> and{" "}
                        <a href="#">Cancellation & Property Booking Policies</a>.
                    </label>
                </div>
            </div>
        </>

    );
};

export default BookingReviewPage;
